import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TypographyComponent } from '../typography/typography.component';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'hyperkit-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  standalone: true,
  imports: [CommonModule, TypographyComponent, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxComponent {
  @Input() checked: boolean = false;
  @Input() label?: string;
  @Input() disabled: boolean = false;
  @Input() indeterminate = false;
  @Input() position: 'left' | 'right' = 'right';

  toggleChecked(): void {
    if (!this.disabled) {
      this.checked = !this.checked;
      this.indeterminate = false; // Reset indeterminate state when toggling
    }
  }
}
